import { HttpClient } from '@angular/common/http';
import { Injectable, Signal } from '@angular/core';
import { SignalStateService } from 'app/core/service/signal-state-service';
import { BehaviorSubject, Observable } from 'rxjs';

interface FuseLoadingState {
    auto: boolean;
    mode: 'determinate' | 'indeterminate';
    progress: number | null;
    show: boolean;
}
@Injectable({ providedIn: 'root' })
export class FuseLoadingService extends SignalStateService<FuseLoadingState> {
    private _urlMap: Map<string, boolean> = new Map<string, boolean>();

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
        super({
            auto: true,
            mode: 'indeterminate',
            progress: null,
            show: false,
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for auto mode
     */
    get auto(): Signal<boolean> {
        return this.select('auto');
    }

    /**
     * Getter for mode
     */
    get mode(): Signal<'determinate' | 'indeterminate'> {
        return this.select('mode');
    }

    /**
     * Getter for progress
     */
    get progress(): Signal<number | null> {
        return this.select('progress');
    }

    /**
     * Getter for show
     */
    get show(): Signal<boolean> {
        return this.select('show');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the loading bar
     */
    // show(): void {
    //     this._show$.next(true);
    // }

    /**
     * Hide the loading bar
     */
    // hide(): void {
    //     this._show$.next(false);
    // }

    /**
     * Set the auto mode
     *
     * @param value
     */
    setAutoMode(value: boolean): void {
        this.setState({ auto: value });
    }

    /**
     * Set the mode
     *
     * @param value
     */
    setMode(value: 'determinate' | 'indeterminate'): void {
        this.setState({ mode: value });
    }

    /**
     * Set the progress of the bar manually
     *
     * @param value
     */
    setProgress(value: number): void {
        if (value < 0 || value > 100) {
            console.error('Progress value must be between 0 and 100!');
            return;
        }
        this.setState({ progress: value });
    }

    /**
     * Sets the loading status on the given url
     *
     * @param status
     * @param url
     */
    _setLoadingStatus(status: boolean, url: string): void {
        // Return if the url was not provided
        if (!url) {
            console.error('The request URL must be provided!');
            return;
        }

        if (status === true) {
            this._urlMap.set(url, status);
            this.setState({ show: true });
        } else if (status === false && this._urlMap.has(url)) {
            this._urlMap.delete(url);
        }

        // Only set the status to 'false' if all outgoing requests are completed
        if (this._urlMap.size === 0) {
            this.setState({ show: false });
        }
    }
}
